/**
 * Galería de Ilustraciones con Propósito — Casa de Fieras
 * JavaScript para modal interactivo, navegación y accesibilidad
 */

(function () {
  'use strict';

  document.querySelectorAll('.galeria-section').forEach(initGaleria);

  function initGaleria(section) {
    var sectionId = section.dataset.sectionId;
    var modal = document.getElementById('galeria-modal-' + sectionId);
    var dataEl = document.getElementById('galeria-data-' + sectionId);

    if (!modal || !dataEl) return;

    var illustrations = [];
    try {
      illustrations = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Galería: Error parsing illustration data', e);
      return;
    }

    var currentIndex = 0;
    var previouslyFocused = null;

    // DOM references
    var backdrop = modal.querySelector('[data-modal-close]');
    var closeBtn = modal.querySelector('.galeria-modal__close');
    var prevBtn = modal.querySelector('[data-modal-prev]');
    var nextBtn = modal.querySelector('[data-modal-next]');
    var commonNameEl = modal.querySelector('[data-modal-common-name]');
    var englishNameEl = modal.querySelector('[data-modal-english-name]');
    var scientificNameEl = modal.querySelector('[data-modal-scientific-name]');
    var descriptionEl = modal.querySelector('[data-modal-description]');
    var imageEl = modal.querySelector('[data-modal-image]');
    var iconBarEl = modal.querySelector('[data-modal-icon-bar]');
    var ctaWrapperEl = modal.querySelector('[data-modal-cta-wrapper]');
    var ctaEl = modal.querySelector('[data-modal-cta]');
    var ctaTextEl = modal.querySelector('[data-modal-cta-text]');

    // ---- Mobile nav bar ----
    // Create a dedicated nav bar for mobile that sits between image and info
    var mobileNavBar = document.createElement('div');
    mobileNavBar.className = 'galeria-modal__mobile-nav-bar';
    mobileNavBar.setAttribute('data-mobile-nav', '');

    var mobilePrevBtn = document.createElement('button');
    mobilePrevBtn.className = 'galeria-modal__nav galeria-modal__nav--prev';
    mobilePrevBtn.setAttribute('aria-label', 'Ilustración anterior');
    mobilePrevBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

    var mobileCounter = document.createElement('span');
    mobileCounter.className = 'galeria-modal__counter';
    mobileCounter.style.cssText = 'font-family:var(--font-body-family,Montserrat,sans-serif);font-size:0.8rem;color:var(--galeria-text,#2c2c2c);opacity:0.6;min-width:40px;text-align:center;';

    var mobileNextBtn = document.createElement('button');
    mobileNextBtn.className = 'galeria-modal__nav galeria-modal__nav--next';
    mobileNextBtn.setAttribute('aria-label', 'Ilustración siguiente');
    mobileNextBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    mobileNavBar.appendChild(mobilePrevBtn);
    mobileNavBar.appendChild(mobileCounter);
    mobileNavBar.appendChild(mobileNextBtn);

    // Insert mobile nav bar inside the modal content, between image and info
    var modalContent = modal.querySelector('.galeria-modal__content');
    var infoSide = modal.querySelector('.galeria-modal__info');
    if (modalContent && infoSide) {
      // DOM order: image-wrapper, then info
      // Insert nav bar before info (between image and info)
      modalContent.insertBefore(mobileNavBar, infoSide);
    }

    // Mobile nav button events
    mobilePrevBtn.addEventListener('click', function () {
      navigate(-1);
    });
    mobileNextBtn.addEventListener('click', function () {
      navigate(1);
    });

    // Bind card clicks
    var cards = section.querySelectorAll('.galeria-card');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var index = parseInt(card.dataset.index, 10);
        openModal(index);
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var index = parseInt(card.dataset.index, 10);
          openModal(index);
        }
      });
    });

    // Close handlers
    closeBtn.addEventListener('click', closeModal);
    // Cerrar al hacer clic en el backdrop (área oscura fuera del container)
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target === backdrop) {
        closeModal();
      }
    });

    // Desktop navigation
    prevBtn.addEventListener('click', function () {
      navigate(-1);
    });

    nextBtn.addEventListener('click', function () {
      navigate(1);
    });

    // Keyboard navigation
    modal.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'Escape':
          closeModal();
          break;
        case 'ArrowLeft':
          navigate(-1);
          break;
        case 'ArrowRight':
          navigate(1);
          break;
        case 'Tab':
          trapFocus(e);
          break;
      }
    });

    // Touch/swipe support — only on the IMAGE area
    // Swipe is bound to the image wrapper only, so scrolling the text/info
    // area is never blocked.
    var touchStartX = 0;
    var touchStartY = 0;
    var modalContainer = modal.querySelector('.galeria-modal__container');
    var imageWrapper = modal.querySelector('.galeria-modal__image-wrapper');

    if (imageWrapper) {
      imageWrapper.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      imageWrapper.addEventListener('touchend', function (e) {
        var touchEndX = e.changedTouches[0].screenX;
        var touchEndY = e.changedTouches[0].screenY;
        var diffX = touchStartX - touchEndX;
        var diffY = touchStartY - touchEndY;
        var threshold = 60;

        // Only treat as swipe if horizontal movement is dominant (> 2x vertical)
        if (Math.abs(diffX) > threshold && Math.abs(diffX) > Math.abs(diffY) * 2) {
          if (diffX > 0) {
            navigate(1);
          } else {
            navigate(-1);
          }
        }
      }, { passive: true });
    }

    function openModal(index) {
      if (index < 0 || index >= illustrations.length) return;

      currentIndex = index;
      previouslyFocused = document.activeElement;

      populateModal(illustrations[index]);
      updateNavButtons();

      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      // Scroll container to top so image is visible first on mobile
      requestAnimationFrame(function () {
        modalContainer.scrollTop = 0;
        closeBtn.focus();
      });
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';

      if (previouslyFocused) {
        previouslyFocused.focus();
      }
    }

    function navigate(direction) {
      var newIndex = currentIndex + direction;
      if (newIndex < 0 || newIndex >= illustrations.length) return;

      currentIndex = newIndex;
      populateModal(illustrations[currentIndex]);
      updateNavButtons();

      // Scroll to top on mobile when navigating
      if (window.innerWidth < 768) {
        modalContainer.scrollTop = 0;
      }
    }

    function populateModal(data) {
      commonNameEl.textContent = data.commonName || '';
      englishNameEl.textContent = data.englishName || '';
      scientificNameEl.innerHTML = data.scientificName ? '<em>' + escapeHtml(data.scientificName) + '</em>' : '';
      descriptionEl.innerHTML = data.description || '';

      if (data.image) {
        imageEl.src = data.image;
        imageEl.alt = data.imageAlt || data.commonName || 'Ilustración';
        imageEl.style.display = '';
      } else {
        imageEl.src = '';
        imageEl.style.display = 'none';
      }

      // CTA Button
      if (data.ctaUrl && data.ctaUrl.trim() !== '') {
        ctaEl.href = data.ctaUrl;
        ctaTextEl.textContent = data.ctaText || 'Ver colección';
        ctaWrapperEl.hidden = false;
      } else {
        ctaWrapperEl.hidden = true;
        ctaEl.href = '#';
      }

      // Icons de fundaciones (0-5)
      iconBarEl.innerHTML = '';
      var iconKeys = ['icon1', 'icon2', 'icon3', 'icon4', 'icon5'];
      var hasIcons = false;

      iconKeys.forEach(function (key) {
        if (data[key]) {
          var img = document.createElement('img');
          img.src = data[key];
          img.alt = 'Logo de fundación aliada';
          img.loading = 'lazy';
          iconBarEl.appendChild(img);
          hasIcons = true;
        }
      });

      if (!hasIcons) {
        iconBarEl.style.display = 'none';
      } else {
        iconBarEl.style.display = '';
      }

      // Update mobile counter
      mobileCounter.textContent = (currentIndex + 1) + ' / ' + illustrations.length;
    }

    function updateNavButtons() {
      var isFirst = currentIndex <= 0;
      var isLast = currentIndex >= illustrations.length - 1;

      // Desktop arrows
      prevBtn.style.display = isFirst ? 'none' : '';
      nextBtn.style.display = isLast ? 'none' : '';

      // Mobile arrows
      mobilePrevBtn.style.display = isFirst ? 'none' : '';
      mobileNextBtn.style.display = isLast ? 'none' : '';

      // Update counter
      mobileCounter.textContent = (currentIndex + 1) + ' / ' + illustrations.length;
    }

    function trapFocus(e) {
      var focusableEls = modal.querySelectorAll(
        'button:not([disabled]):not([hidden]):not([style*="display: none"]):not([style*="display:none"]), [href]:not([hidden]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var visibleEls = Array.prototype.filter.call(focusableEls, function (el) {
        return el.offsetParent !== null;
      });

      if (visibleEls.length === 0) return;

      var firstEl = visibleEls[0];
      var lastEl = visibleEls[visibleEls.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    // ---- Responsive: show/hide mobile vs desktop nav ----
    function handleResize() {
      var isMobile = window.innerWidth < 768;
      mobileNavBar.style.display = isMobile ? '' : 'none';
      // Desktop arrows are positioned absolute, hide on mobile
      prevBtn.style.visibility = isMobile ? 'hidden' : '';
      nextBtn.style.visibility = isMobile ? 'hidden' : '';
      prevBtn.style.position = isMobile ? 'absolute' : '';
      nextBtn.style.position = isMobile ? 'absolute' : '';
      // Ensure desktop arrows don't interfere on mobile
      if (isMobile) {
        prevBtn.setAttribute('aria-hidden', 'true');
        nextBtn.setAttribute('aria-hidden', 'true');
        prevBtn.tabIndex = -1;
        nextBtn.tabIndex = -1;
      } else {
        prevBtn.removeAttribute('aria-hidden');
        nextBtn.removeAttribute('aria-hidden');
        prevBtn.tabIndex = 0;
        nextBtn.tabIndex = 0;
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check
  }
})();
